import { Component, OnInit, Input} from '@angular/core';
import { User } from '../classes/User';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

	@Input() origPath;
	@Input() params;

	user: User;
	menuOpen: boolean;
	userHover: boolean;
	activeModal = '';
	err: string = "";
	authToken: string | null;

	constructor(
		private router: Router, 
		private auth: AuthService, 
		private route: ActivatedRoute) { }

	ngOnInit(): void {
	  console.log("header loaded");
	  let token = this.auth.getToken();
      if (token) this.getUserInfo();
      else this.removeUserInfo();
	}

	getUserInfo() {
	let userObs = this.auth.getHostDetail().subscribe(
	    (res: any) => {
		    this.user = new User(res);
		    localStorage.setItem("userid", this.user.userid);
		    localStorage.setItem("user_detail", JSON.stringify(this.user));
		    if (!this.user.venmo) {
				let dismissed = localStorage.getItem("dismissedVenmo");
				if (!dismissed) this.activeModal = "setVenmo";
			}
		},
		(err) => {
		    if (err.status === 401) { this.removeUserInfo(); }
		    else {
		      this.err = err.error.detail;
		      if (this.err.includes("[Errno 111]")) {
		        this.err = "Can't connect to redis. Please contact system administrator.";
		      }
		    }
		  }
		);
	}

	removeUserInfo() {
	    this.closeMenu();
	    this.activeModal = "";
	    this.user = null;
	    localStorage.removeItem("user_detail");
	    localStorage.removeItem("userid");
	    this.auth.setToken("");
	    this.authToken = "";
	    const basePath = this.origPath.split("/")[1];
	    if (basePath !== "forgot-password" && basePath !== "new-password") {
	      this.router.navigate(["/login"]);
	    }
	}

	confirmLogout() {
		this.menuOpen = false;
		this.activeModal = 'logoutConfirm'
	}

	logoutUser() {
		this.removeUserInfo();
	}

	navTo(loc: any[]) {
		this.menuOpen = false;
		this.router.navigate(loc);
	}

	closeModalAndNavTo(loc: any[]) {
		this.activeModal = "";
		this.navTo(loc);
	}

	closeMenu() {
		this.menuOpen = false;
	}

	closeAndDismiss() {
		this.activeModal = "";
		localStorage.setItem("dismissedVenmo", "true");
	}

}
